import { HTMLAttributes } from 'react'

const IconExport = (props: HTMLAttributes<HTMLOrSVGElement>) => {
  return (
    <svg width="16" height="17" {...props} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.55542 7.94227L13.111 3.38672"
        stroke="#9CA3AE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5556 5.60807V2.94141H10.8889"
        stroke="#9CA3AE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.44434 2.94141H6.33322C3.55545 2.94141 2.44434 4.05252 2.44434 6.83029V10.1636C2.44434 12.9414 3.55545 14.0525 6.33322 14.0525H9.66656C12.4443 14.0525 13.5554 12.9414 13.5554 10.1636V9.05252"
        stroke="#9CA3AE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconExport
